import { IconProps } from '@velocity-exchange/icons';
import { ComponentType } from 'react';
import Button from 'src/components/primitives/Button/Button';
import { cm } from 'src/utils/classNames';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName, WithChildren {
	onClick: () => void;
	dataTestId?: string;
	leftIcon?: ComponentType<IconProps>;
	isLoading?: boolean;
}

export default function ConnectWalletModalButton({
	className,
	...rest
}: Props) {
	return (
		<Button
			size="lg"
			variant="stroke"
			className={cm('gap-x-sm', className)}
			{...rest}
		/>
	);
}
